require("component-responsive-frame/child");
var $ = require("./lib/qsa");

var filterNav = $.one("nav.filters");

var rows = $(".facilities tbody tr");
rows = rows.map(function(r) {
  return {
    element: r,
    county: r.getAttribute("data-county")
  };
});

filterNav.addEventListener("change", function() {
  var counties = $(`[name="county-filter"]:checked`).map(e => e.value);

  rows.forEach(function(item) {
    var matched = true;
    if (counties.length && (counties.indexOf(item.county) === -1)) {matched = false};

    item.element.classList[matched ? "remove" : "add"]("hidden");
  });
});